import { useMemo } from "react";

import { getUserData } from "@/utils/auth";
import {
  AppRole,
  PageKey,
  canEdit as permCanEdit,
  canView as permCanView,
  getPermission,
  toAppRole,
} from "@/utils/permissions";

export function useAppRole(): AppRole | null {
  return useMemo(() => toAppRole(getUserData()?.role ?? null), []);
}

export function usePermission(key: PageKey) {
  const role = useAppRole();
  return useMemo(() => {
    if (!role) return { role: null, view: false, edit: false };
    const perm = getPermission(role, key);
    return { role, view: perm.view, edit: perm.edit };
  }, [role, key]);
}

export function useCanView(key: PageKey): boolean {
  const role = useAppRole();
  return useMemo(() => permCanView(role, key), [role, key]);
}

export function useCanEdit(key: PageKey): boolean {
  const role = useAppRole();
  return useMemo(() => permCanEdit(role, key), [role, key]);
}
